import { render } from "./AlertSuccessComponent.vue?vue&type=template&id=2330e6fa"
import script from "./AlertSuccessComponent.vue?vue&type=script&lang=js"
export * from "./AlertSuccessComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__